import XLSX from 'xlsx';
// ...
export const exportToExcel = (columns, data, fileName) => {
  const columnInfo = columns.reduce(
    (acc, column) => {
      const headerLabel = column.title || column.field;
      acc.header.push(headerLabel);
      acc.map[column.field] = headerLabel;
      return acc;
    },
    { map: {}, header: [] },
  );

  const mappedData = data.map((row) =>
    Object.entries(row).reduce((acc, [key, value]) => {
      if (columnInfo.map[key]) {
        acc[columnInfo.map[key]] = value;
      }
      return acc;
    }, {}),
  );

  var ws = XLSX.utils.json_to_sheet(mappedData, {
    header: columnInfo.header,
  });

  var wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  XLSX.writeFile(wb, `${fileName}.xlsx`);
};
